import * as React from "react";

import { cn } from "@/lib/utils";

//Text input fields in Sukha have the following properties by default:
//Background is dark green/grey.
//Editable text is Sukha Gold (regardless of whether it is a required or optional field).
//Field have no ring/border EXCEPT on hover or when focused, both of which are a Sukha Gold ring.  Hover is 1px, focus is 2px.
//In a validated field, when the input is invalid the ring is a red ring and the text is red.
//When the field is disabled, the text is a muted grey and the ring is a muted grey.
//Placeholder text is a muted grey.

//The above defaults do not apply to the TaskCell text and the AddTaskCell text.

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Layout
        "flex px-3 py-1",
        // Dimensions
        "h-9 w-full min-w-0",
        // Text styles (Gold text)
        "text-base md:text-sm text-secondary-300",
        // Placeholder text and selection
        "placeholder:text-gray-400 selection:bg-primary selection:text-secondary-300",
        // Background and basic appearance
        "bg-primary-900 rounded-md shadow-xs outline-hidden",
        // Using rings for hover and focus instead of borders (to prevent layout shift)
        // Using inset ring to prevent clipping
        "ring-0 ring-offset-0 hover:ring-1 hover:ring-inset hover:ring-secondary-300/80 focus:ring-2 focus:ring-inset focus:ring-secondary-300",
        // File input styling
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // Validation states
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        // Disabled state
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        // Native date/datetime/month/time picker affordance follows field text colour (Chrome/Safari use a
        // separate pseudo-element that does not inherit `color` unless we tie it explicitly; `scheme-dark`
        // aligns built-in glyphs with dark fields).
        "scheme-dark",
        "[&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-100 [&::-webkit-calendar-picker-indicator]:[color:currentcolor]",
        "[&::-moz-calendar-picker-indicator]:cursor-pointer [&::-moz-calendar-picker-indicator]:opacity-100 [&::-moz-calendar-picker-indicator]:[color:currentcolor]",
        // Transitions
        "transition-[color,box-shadow]",
        className
      )}
      {...props}
    />
  );
}

export { Input };
